module.exports = __webpack_public_path__ + "img/T6.06f3968c.png";